import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypePostShippingLabelsDownloadParams } from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 목록 전체 엑셀 다운로드 API
 */
const fetchPostShippingLabelsDownload = async (params: TypePostShippingLabelsDownloadParams): Promise<void> => {
  const response = await axiosInstance.post(API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_EXCEL_DOWNLOAD, params, {
    responseType: 'blob',
  });

  downloadBlobDataFile(response);
};

/**
 * [운송장 관리] 운송장 목록 전체 엑셀 다운로드 Mutation Hook
 */
export const usePostShippingLabelsDownloadMutation = () => {
  return useDownloadMutation(fetchPostShippingLabelsDownload);
};
